import React, { useContext, Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import {
    InfoLabel,
    Icon,
    ModalNextProvider,
    Loader,
    CurrencyValue,
    Link as DownloadLink
} from '@jutro/components';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {
    TranslatorContext, LocaleContext,
    IntlContext,
    withIntl
} from '@jutro/locale';
import { GatewayClaimService } from 'gw-capability-ri-claim';
import { withDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import metadata from './ClaimInfos.metadata.json5';
import claimInfosStyles from './ClaimInfos.module.scss';
import messages from './ClaimInfos.messages';

class ClaimInfos extends Component {
    static propTypes = {

        match: PropTypes.shape({
            url: PropTypes.string,
            params: PropTypes.shape({
                claimNumber: PropTypes.string
            })
        }).isRequired,

        history: PropTypes.shape({
            push: PropTypes.func,
            goBack: PropTypes.func,
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired,

        authHeader: PropTypes.shape({
            Authorization: PropTypes.string
        }).isRequired,

    };

    static contextType = TranslatorContext;

    constructor(props) {
        super(props);

    }

    state = {
        claimDetailsData: '',
        isClaimDetailsPageVisible: true,
        isLoading: true,
        coverage: 0,
        redirectPath: {},
        uploadToken: null,
        documentAlert: ''
    };

    componentDidMount = () => {
        const {
            history: { location: state = {} }
        } = this.props;
        const redirectPathValues = state;
        
        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/ri-claims'
        });
        this.getClaimDetailsResponse();
    }

    getClaimDetailsResponse = () => {
        const { authHeader, match } = this.props;
        GatewayClaimService.getClaimDetail(match.params.claimNumber, authHeader).then((claimResponse) => {
            const claimDetails = claimResponse;
                const responseData = {
                    claim: claimDetails,
                    notes: [],
                    claimPayments: [],
                    claimServices: [],
                    activities: {},
                    reporter: '',
                    claimLosslocation: {},
                    selectedVehicleIncident: {},
                    vehicles: [],
                    claimContactsVendors: [],
                    claimHospitalsDays: claimDetails.hospitalDays,
                    claimContactsWithoutAgent: []
                };
                this.setState({
                    claimDetailsData: responseData,
                    isLoading: false
                });
        }).catch(() => {
            this.setState({ isLoading: false });
        });
        // if (_.isFunction(GatewayClaimService.addRecentlyViewedClaim)) {
        //     GatewayClaimService.addRecentlyViewedClaim(match.params.claimNumber, authHeader);
        // }
    }

    getCell = (item, index, { id: property }) => {
        return item[property];
    };

    getDataTableCell = (item, index, { path: property }) => {
        return item[property];
    }

    getFormatCurrency = (deductible) => {
        let formattedAmount = '';
        if (deductible) {
            const { amount, currency } = deductible;
            if (amount && currency) {
                const intl = useContext(IntlContext);
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency,
                        currencyDisplay: 'code'
                    }
                );
            }
        }
        return formattedAmount;
    }

    getBackToPreviousState = () => {
        const { history } = this.props;
        const { redirectPath } = this.state;
        const redirectpath = {
            pathname: redirectPath,
            state: 'claims'
        };
        history.push(redirectpath);
    };


    getClaimsDetailsHeader = (claimDetailsData) => {
        if (_.isEmpty(claimDetailsData)) {
            return null;
        }
        const claimStatus = _.get(claimDetailsData, 'status');
        const claimNo = `(${claimDetailsData.claimNumber})`;
        return (
            <>
                 <div className={claimInfosStyles.gwTypeWithLOB}>

                    <Icon icon="mi-assignment_late" className={claimInfosStyles.syncIcon} />
                    <h1 className={claimInfosStyles.gwPageTitle}>{messages.claimsDetailTitle.defaultMessage} {claimNo}</h1>
                    <InfoLabel
                        id="infoStatus"
                        size="medium"
                        className={claimInfosStyles.gwInfoStatus}
                        type="info"
                    >
                        {claimStatus}
                    </InfoLabel>
                </div>
            </>
        );
    };

    getClaimNumber = (claimDetailsData, translator) => {
        return 'RE333333'
        // translator(messages.claimDetailNumber,
        //     { num: claimDetailsData.claimNumber });
            
    };

    getPolicyNumber = (claimDetailsData) => {
        const redirectPath = `/policies/${claimDetailsData.policyNumber}/summary`;
        if (appConfig.persona === 'policyholder') {
            return claimDetailsData.policyNumber;
        }
        return (
            <Link to={redirectPath} className={claimsInfoStyles.gwClaimDetailsLink}>
                {claimDetailsData.policyNumber}
            </Link>
        );
    };
    
    
    getCurrencyCell = (item, index, { id: property }) => {
        // const translator = this.context;
        // const toolTipMessage = {
        //     paid: translator(messages.totalPayments),
        //     netIncurred: translator(messages.totalIncurrednet)
        // };
        return (
            <span>
                    <CurrencyValue
                    id="currency-value"
                    showFractions
                    value={item[property]}
                    />
            </span>
        );
    };

    
    // getAccountNumber = (claimDetailsData) => {
    //     const redirectPath = `/accounts/${claimDetailsData.policy.accountNumber}/summary`;
    //     if (appConfig.persona === 'policyholder') {
    //         return claimDetailsData.policy.accountNumber;
    //     }
    //     return (
    //         <Link to={redirectPath} className={claimDetailsStyles.gwClaimDetailsLink}>
    //             {claimDetailsData.policy.accountNumber}
    //         </Link>
    //     );
    // };

    getLossDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData.lossDate), { year: 'numeric', month: 'short', day: 'numeric' });
    };

    getReportedByName = (claimDetailsData, translator) => {
        if (claimDetailsData.claimReporter.reportedBy.displayName) {
            return claimDetailsData.claimReporter.reportedBy.displayName;
        }
        return translator(messages.unknown);
    };

    getPaidData = (claimDetailsData, intl) => {
        const paidData = [{
            category: "Medical",
            incurred: claimDetailsData.medIncurredAmount,
            paid: claimDetailsData.medPaidAmount
        },
        {
            category: "Indemnity",
            incurred: claimDetailsData.indNVRIncurredAmount,
            paid: claimDetailsData.indNVRPaidAmount
        },
        {
            category: "Voc. Rehabilitation",
            incurred: claimDetailsData.indVRIncurredAmount,
            paid: claimDetailsData.indVRPaidAmount
        },
        {
            category: "ALAE",
            incurred: claimDetailsData.allocatedIncurredAmount,
            paid: claimDetailsData.allocatedPaidAmount
        },
        {
            category: "Total",
            incurred: claimDetailsData.totalIncurredWithExpenses,
            paid: claimDetailsData.amountPaidWithExpenses
        }];
        return paidData;
    };

    getPrimaryContactName = (claimDetailsData) => {
        if (claimDetailsData.mainContact && claimDetailsData.mainContact.displayName) {
            return claimDetailsData.mainContact.displayName;
        }
        return '';
    };

    getAdjusterName = (claimDetailsData, translator) => {
        if (claimDetailsData.adjuster.displayName) {
            return claimDetailsData.adjuster.displayName;
        }
        return translator(messages.unknown);
    };

    toggleVehicleDetailsContainer = (claimDetailsData) => {
        if (
            claimDetailsData.claim.policy.policyType === 'PersonalAuto'
            && claimDetailsData.vehicles.length > 0
        ) {
            return true;
        }
        return false;
    };

    getCoverageForSelectedVehicle = (claimDetailsData, translator) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetailsData);
        if (!_.isEmpty(selectedVehicle)) {
            return translator(
                messages.coveragesFor,
                {
                    vehicleMake: selectedVehicle[coverage].make,
                    vehicleModel: selectedVehicle[coverage].model
                }
            );
        }
        return '';
    };

    getLossLocation = (claimDetailsData) => {
        let location = '';
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            location = claimDetailsData.lossLocation.displayName;
            location.replace('\n', ', ');
        }
        return location;
    };

    getLossLocationVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            return true;
        }
        return false;
    };

    getEmployerNotifiedVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossType === 'WC') {
            return true;
        }
        return false;
    };

    getEmployerNotifiedDate = (claimDetailsData, intl) => {
        let employernotifiedDate;
        if ((claimDetailsData.lossType === 'WC') && (claimDetailsData.lobs.workersComp.dateReportedToEmployer)) {
            employernotifiedDate = intl.formatDate(
                new Date(claimDetailsData.lobs.workersComp.dateReportedToEmployer),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return employernotifiedDate;
    };

    getHospitalDaysVisibility = (claimDetailsData) => {
        if (claimDetailsData.hospitalDays) {
            return true;
        }
        return false;
    };
    
    getReportedDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData.reportedDate), { year: 'numeric', month: 'short', day: 'numeric' });
    };


    getDataCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'documentName':
                toolTipMessage = translator(messages.documentsName);
                break;
            case 'documentDate':
                toolTipMessage = translator(messages.documentsDateModified);
                break;
            default:
                toolTipMessage = '';
        }
        return (
            <span title={toolTipMessage}>
                {item[property]}
            </span>
        );
    };


    formatAMPM = (date) => {
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const strTime = `${hours}:${minutes} ${ampm}`;
        return strTime;
    };

    formatPaymentDate = (claimPaymentDate, intl) => {
        return claimPaymentDate !== undefined ? intl.formatDate(
            new Date(claimPaymentDate), { year: 'numeric', month: 'short', day: 'numeric' }
        ) : ' ';
    };

    getPaymentGrossAmount = (paymentGrossAmount) => {
        let grossAmount;
        const { amount, currency } = paymentGrossAmount;
        if (amount && currency) {
            const intl = useContext(IntlContext);
            grossAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'code'
                }
            );
        }
        return `${grossAmount}`;
    };

    render() {
        const { intl, location: { state } } = this.props;
        const selectedTab = _.get(state, 'selectedTab', 'summaryTab');
        const {
            claimDetailsData,
            isClaimDetailsPageVisible,
            isLoading,
            documentAlert,
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        if (!claimDetailsData) {
            return null;
        }

        const overrides = {
            claimDetailNumber: {
                value: this.getClaimNumber(claimDetailsData.claim, translator)
            },
            tabClaimsDetailsTitle: {
                content: this.getClaimsDetailsHeader(claimDetailsData.claim)
            },             
            claimState: {
                value: translator({
                    id: `typekey.ClaimState.${claimDetailsData.claim.claimState}`,
                    defaultMessage: claimDetailsData.claim.claimState
                })
            },
            policyNumber: {
                value: this.getPolicyNumber(claimDetailsData.claim)
            },
            dateOfLoss: {
                value: this.getLossDate(claimDetailsData.claim, intl)
            },
            reportedDate: {
                value: this.getReportedDate(claimDetailsData.claim,intl)
            },
            claimDetailsPage: {
                visible: isClaimDetailsPageVisible
            },
            // summaryRightDiv: {
            //     visible: this.canAccessFinancials()
            // },
            summaryPaidTableGrid: {
                data: this.getPaidData(claimDetailsData.claim, intl)
            },
            // partyTableContainer: {
            //     visible: ['producer', 'vendor', 'csr'].includes(appConfig.persona)
            // },
            claimDetailsTabset: {
                defaultActiveTab: selectedTab
            },
            vendorTableContainer: {
                visible: appConfig.persona === 'policyholder'
            },
            //...this.generatePaymentDetailsOverrides(intl),
            //...this.generateServiceDetailsOverrides(intl)
        };
        const resolvers = {
            resolveCallbackMap: {
                getBackToPreviousState: this.getBackToPreviousState,
                getCell: this.getCell,
                getDataCell: this.getDataCell,
                getCurrencyCell: this.getCurrencyCell,
                onRowClick: (data) => {
                    _.set(data, 'expanded', !data.expanded);
                }
            },
            resolveClassNameMap: claimInfosStyles
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, claimDetailsData, id, path, overrides);
        };
        
        const claimDetailsPage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimDetailsData}
                overrideProps={overrides}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        );

        return <div className={cx(claimInfosStyles.claimInfos)}>{claimDetailsPage}</div>;
    }
}

export const ClaimDetailsComponent = ClaimInfos;
export default withRouter(
    withIntl(withAuthenticationContext((ClaimInfos)))
);
